'use strict';

angular.module('lingApp')
  .factory('RipRoute', function($window, $location) {
    function getParam(key) {
      if ($window.location.search.length <= 1) {
        return null;
      }

      var params = $window.location.search.substring(1).split('&');
      var pair;
      for (var i = 0; i < params.length; ++i) {
        pair = params[i].split('=');
        if (decodeURIComponent(pair[0]) === key) {
          return decodeURIComponent(pair[1]);
        }
      }

      return null;
    }

    return {
      getParam: getParam,
      makeRoute: function(paths) {
        return ($location.protocol()
                + '://'
                + $location.host()
                + ':'
                + $location.port()
                + $window.location.pathname
                + '#/'
                + _.map(paths, encodeURIComponent).join('/'));
      }
    };
  });
